// libs
import React, { useMemo } from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// widgets
import Tile from '@/widgets/Tile';
import GenerateReportButton from '@/widgets/GenerateReportButton';
import MetricsTile from '@/widgets/MetricsTile';
import BudgetProgressBar from '@/widgets/BudgetProgressBar';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { ROLES } from '@local/typedefs/dist/common/userRoles';
// stores
import useDashboardStore from '@/stores/Dashboard';
import useAccountStore from '@/stores/account';
// helper
import { getParsedMetricValue } from '@/helpers/utils';
import { formatNumberIntl, prefixWithRupee } from '@/helpers/utils';
// styles
import styles from './AggregatedMetrics.module.scss';
import { DashboardTooltips } from '@/constants/tooltips';
const AggregatedMetrics = () => {
    const { aggregatedMetrics, activeCampaigns } = useDashboardStore();
    const maxBudget = useMemo(() => activeCampaigns.reduce(function (cuurentBudget, nextCampaign) {
        return cuurentBudget + nextCampaign.budget;
    }, 0), [activeCampaigns]);
    const permissions = useAccountStore((state) => state.loggedInAccountDetails.permissions);
    const haveReportDownloadPermission = useMemo(() => permissions.includes(ROLES.DOWNLOAD_REPORT), [permissions]);
    return (React.createElement(Tile, { className: styles.tile },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.headerLeftContent },
                React.createElement("div", { className: styles.headerLeftContentLineOne },
                    React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Low_Emphasis },
                        "Performance data of your Active Campaigns (",
                        activeCampaigns.length,
                        ")")),
                React.createElement("div", { className: styles.headerLeftContentLineTwo },
                    React.createElement(Text, { variant: DlsFontVariants.header_H2_Black, color: DlsColorTokens.text_Highest_Emphasis }, "Ads Summary"))),
            React.createElement("div", { className: styles.headerRightContent },
                React.createElement(BudgetProgressBar, { max: maxBudget.toFixed(0), spent: aggregatedMetrics.budgetBurnt.toFixed(0) }))),
        React.createElement("hr", { className: styles.divider }),
        React.createElement("div", { className: styles.performance },
            React.createElement("div", { className: styles.performanceTitle },
                React.createElement(Text, { variant: DlsFontVariants.header_H4_Black, color: DlsColorTokens.text_High_Emphasis }, "Overall Performance"),
                haveReportDownloadPermission && (React.createElement(GenerateReportButton, { onClick: () => void 0, label: "Generate Report" }))),
            React.createElement("div", { className: styles.performanceMetrics },
                React.createElement(MetricsTile, { label: "Total Impressions", metric: getParsedMetricValue(formatNumberIntl({
                        value: aggregatedMetrics === null || aggregatedMetrics === void 0 ? void 0 : aggregatedMetrics.impressions,
                    })), tooltip: DashboardTooltips.TOTAL_IMPRESSIONS }),
                React.createElement(MetricsTile, { label: "Cart Additions", metric: getParsedMetricValue(formatNumberIntl({
                        value: aggregatedMetrics === null || aggregatedMetrics === void 0 ? void 0 : aggregatedMetrics.addToCart,
                    })), tooltip: DashboardTooltips.CART_ADDITIONS }),
                React.createElement(MetricsTile, { label: "GMV", metric: prefixWithRupee(getParsedMetricValue(formatNumberIntl({
                        value: aggregatedMetrics === null || aggregatedMetrics === void 0 ? void 0 : aggregatedMetrics.gmv,
                    }))), tooltip: DashboardTooltips.GMV }),
                React.createElement(MetricsTile, { label: "ROI", metric: getParsedMetricValue(formatNumberIntl({
                        value: aggregatedMetrics === null || aggregatedMetrics === void 0 ? void 0 : aggregatedMetrics.roi,
                        maximumFractionDigits: 2,
                    })), tooltip: DashboardTooltips.ROI })))));
};
export default AggregatedMetrics;
